import { Pressable } from '../../../../../../mads';
import { Close } from '../../../../../../mads/icons';

import { colors } from '@indeed/ifl-tokens';
import React from 'react';
import { StyleSheet } from 'react-native';

interface CloseButtonProps {
    onPress: () => void;
    accessibilityLabel: string;
    iconColor?: string;
}

/**
 * A reusable close button component for headers using the CloseIcon
 * from the IFL design system.
 */
export function CloseButton({
    onPress,
    accessibilityLabel,
    iconColor = colors.foreground.strong,
}: CloseButtonProps) {
    return (
        <Pressable
            onPress={onPress}
            sx={styles.button}
            accessibilityLabel={accessibilityLabel}
            accessibilityRole="button"
        >
            <Close color={iconColor} />
        </Pressable>
    );
}

const styles = StyleSheet.create({
    button: {
        marginLeft: 30,
        paddingBottom: 4,
    },
});
